import { useEffect } from 'react';
import { Questionnaire } from '../../../../types';
import { useDispatch } from 'react-redux';
import { setInitialQuestions } from '../../../../../../redux/questionnaire/actions';

export const usePutQuestionsToRedux = (questionnaire?: Questionnaire) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const allQuestions =
      questionnaire?.sections?.flatMap(section =>
        section.questions.map(question => ({
          ...question,
          section: section.section
        }))
      ) || [];

    if (allQuestions.length > 0) {
      dispatch(setInitialQuestions(allQuestions));
    }
  }, [dispatch, questionnaire]);
};
